import React, { useEffect, useState } from 'react';

import { Banner, Text } from '@shopify/polaris';

/**
 * Features that stay dormant until the merchant grants the matching optional scope.
 */
const SCOPE_FEATURES = {
    read_returns: 'Automatically voiding tax free forms when an order is returned',
    read_all_orders: 'Searching orders placed more than 60 days ago',
};

function ScopeBanner() {
    const [missing, setMissing] = useState([]);

    useEffect(() => {
        shopify.scopes
            .query()
            .then(({ granted, optional }) => setMissing(optional.filter((scope) => !granted.includes(scope))))
            // ponytail: if we can't tell, say nothing rather than warn about a permission that may be granted.
            .catch(() => setMissing([]));
    }, []);

    if (!missing.length) {
        return null;
    }

    async function handleGrantAccess() {
        const { result } = await shopify.scopes.request(missing);

        if (result === 'granted-all') {
            setMissing([]);
        }
    }

    return (
        <Banner
            tone="warning"
            title="Additional permissions needed"
            action={{ content: 'Grant access', onAction: handleGrantAccess }}
        >
            <Text as="p">The following features stay off until a staff member who can install apps grants access.</Text>
            <ul>
                {missing.map((scope) => (
                    <li key={scope}>{SCOPE_FEATURES[scope] ?? scope}</li>
                ))}
            </ul>
        </Banner>
    );
}

export default ScopeBanner;
